import { DesktopMacOutlined } from "@mui/icons-material";
import type { ModuleDescriptor } from "src/app/moduleDescriptor";
import { LegacyMetricsPage } from "./LegacyMetricsPage.page";

/**
 * Legacy Metrics: route and drawer entry, gated on `metrics.legacy.read`.
 * customer-portal-api's LegacyMetrics module owns that entitlement and enforces
 * it on every /api/legacy-metrics endpoint.
 */
export const legacyMetricsModule: ModuleDescriptor = {
  id: "legacy-metrics",
  path: "/legacy-metrics",
  element: <LegacyMetricsPage />,
  requiredEntitlements: ["metrics.legacy.read"],
  nav: { label: "Legacy Metrics", icon: <DesktopMacOutlined />, section: "primary" },
};
